<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header"/>
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        v-model="selected"
        value-key="uuid"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :baseDropDownVisible="accionesFinales.length > 0"
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesFinales" :key="action.id">
              <base-button-item-list theme="dark"  @click="executeAction(action)">
                <base-icon :name="action.icon" class="mr-2" />
                {{ action.name }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/UploadErrorsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getUploadInvoiceErrors } from '@/services/invoices/getUploadInvoiceErrors'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import { exportExcel } from '@/services/excel/exportExcel'
import _ from 'lodash'
export default {
  name: 'uploaded-invoices-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
  },
  data: function () {
    return {
      idVista: 54,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      accionesBase: [
        {
          id: 1,
          icon: 'editpencil',
          name: i18n.t('app.modify')
        },
        {
          id: 2,
          icon: 'retry',
          name: i18n.t('tipos.accion.retry')
        },
        {
          id: 3,
          icon: 'check',
          name: i18n.t('app.check_as_readed')
        },
      ],
      loadingExcel: false,
      spanish: true,
      header: {
        title: i18n.t('avisos.upload_errors.header'),
        icon: 'docblack',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'uploaderrors',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    accionesFinales () {
      // TODO - Realizar acciones 1 y 2
      const acciones = this.accionesBase.filter(x => x.id === 3)
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 1) {
        return acciones.filter(x => [2, 3].includes(x.id))
      }
      return acciones
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
  },
  watch: {
    $route (to, from) {
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    }
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('uploaderrors.cliente'), value: this.actualFilterNav, compareType: 'function', callback: (item, value, key) => item?.cliente?.idCliente === value }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    this.data = await this.applyFilters()
  },
  methods: {
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id }, compareType: 'function', callback: (item, value, key) => item?.cliente?.idCliente === value }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.id === 1) { // Modificar

      } else if (this.selectedAction.id === 2) { // Reintentar
        
      } else { // Marcar como leido
        this.data = this.data.filter(x => !this.selected.includes(x.uuid))
        this.unselect()
        if (this.data.length === 0) {
          this.$store.dispatch('app/removeAnnouncement', 'notices/uploaderrors')
        } else {
          this.$store.dispatch('app/updateAnnouncement', { link: 'notices/uploaderrors', params: this.data, NumeroAvisos: this.data.length })
        }
        this.applyFilters()
      }
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      try {
        var data = []
        if (this.selected.length > 0) {
          data = this.selected
        } else {
          const pageSize = this.pagination.pageSize
          const currentPage = this.pagination.currentPage
          const filters = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
          const extraparams = _.cloneDeep(filters)
          Object.entries(extraparams).forEach(([key, value]) => { extraparams[key] = this.discard(['label', 'value'], value) })
          const params = {
            empresa: filters.empresa?.value?.idCliente,
            'distribuidor.idDistribuidor': filters['distribuidor.idDistribuidor']?.value?.idDistribuidor,
            Respuesta: filters.Respuesta?.value,
            codError: filters.codError?.value,
            msgError: filters.msgError?.value,
            extraparams,
            paginate: false
          }
          const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort, true)
          try {
            data = await this.getItemsData(objOrder, params)
          } catch (error) {
            this.$store.commit('setIsLoading', false)
            this.doFeedback(i18n.t('feedback.error.general'))
          }
          this.$store.commit(this.vuexnamespace + '/setCurrentPage', currentPage)
          this.$store.commit(this.vuexnamespace + '/setPageSize', pageSize)
        }
        exportExcel({
          data: data.map(x => ({ facturaName: x.Respuesta, success: !x.blnError, codError: x.codError, msgError: x.msgError })),
          fileName: 'subidas-en-error.csv' 
        })
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const extraparams = _.cloneDeep(data)
      Object.entries(extraparams).forEach(([key, value]) => { extraparams[key] = this.discard(['label', 'value'], value) })
      const params = {
        empresa: data.empresa ? data.empresa.value.idCliente : null,
        'distribuidor.idDistribuidor': data['distribuidor.idDistribuidor'] ? data['distribuidor.idDistribuidor'].value.idDistribuidor : null,
        Respuesta: data.Respuesta ? data.Respuesta.value : null,
        codError: data.codError ? data.codError.value : null,
        msgError: data.msgError ? data.msgError.value : null,
        extraparams
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort, true)
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return this.data
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      if (res.blnError === false) {
        this.data = res.respuesta
        const pagination = {
          total: res.meta?.total,
          currentPage: res.meta?.currentPage,
          totalPages: res.meta?.lastPage,
          pageSize: res.meta?.perPage
        }
        this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
        this.$store.commit('setIsLoading', false)
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
      }
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (orders, filters) {
      const data = getUploadInvoiceErrors(orders, filters)
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    unselect: function () {
      this.selected = []
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
